import { render, staticRenderFns } from "./soloCalendar.vue?vue&type=template&id=3ca5d17c&scoped=true"
import script from "./soloCalendar.vue?vue&type=script&lang=js"
export * from "./soloCalendar.vue?vue&type=script&lang=js"
import style0 from "./soloCalendar.vue?vue&type=style&index=0&id=3ca5d17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5d17c",
  null
  
)

export default component.exports